



































import {defineComponent, PropType} from "@vue/composition-api";
import AppLayout from "@tool/Layouts/AppLayout.vue";
import Breadcrumbs from "@tool/Components/Breadcrumbs.vue";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import BlockMessage from "@base/Components/BlockMessage.vue";
import useInertiaTable from "@tool/Helpers/useInertiaTable";
import InertiaDatatable from "@base/Components/InertiaDatatable.vue";
import {ProjectEntityInterface, TeamEntityInterface} from "@tool/tool.types";
import {ResourceCollectionInterface} from "@base/base.types";
import AppTeamLayout from "@tool/Pages/App/Teams/AppTeamLayout.vue";

export default defineComponent({
    components: {
        AppTeamLayout,
        Breadcrumbs,
        AppLayout,
        ThemeBlock,
        BlockMessage,
        InertiaDatatable
    },
    props: {
        team: {
            type: Object as PropType<TeamEntityInterface>,
            required: true
        },
        projects: {
            type: Object as PropType<ResourceCollectionInterface<ProjectEntityInterface>>,
            required: true,
        },
    },
    setup(props) {

        const table = useInertiaTable(props.projects, [{
            key: 'name',
            label: 'Name'
        }, {
            key: 'actions',
            label: '',
            class: 'actions'
        }]);

        return {
            table
        }
    }
})
